import React from 'react';

import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './MobileAppPopup.module.scss';

const MobileQRVector = dynamic(() => import('./vectors/mobile-qr.svg'));

function MobileAppPopup() {
  const router = useRouter();
  const isHome = React.useMemo(() => router.asPath === '/', [router?.asPath]);

  const [isVisible, setIsVisible] = React.useState(true);

  React.useEffect(() => {
    if (!window.localStorage.getItem('hide-mobile-app-modal')) {
      setIsVisible(true);
    }
  }, []);

  if (!isVisible || !isHome) return null;

  const handleOnClose = () => {
    setIsVisible(false);
    window.localStorage.setItem('hide-mobile-app-modal', true);
  };

  return (
    <div className={styles.wrapper}>
      <button type="button" className={styles.closeBtn} onClick={handleOnClose}>
        <FontAwesomeIcon icon={faTimes} />
      </button>

      <Image
        src="/images/mobile-banner-bg.gif"
        alt="Mobil Banner BG"
        style={{ position: 'absolute', top: 0, left: 0, opacity: 0.6, borderRadius: '12px', zIndex: -1 }}
        width={128}
        height={173}
      />

      <MobileQRVector className={styles.downloadVector} />

      <div className={styles.contentWrapper}>
        <p>For better experience download our app</p>
      </div>
    </div>
  );
}

export default MobileAppPopup;
